import React from 'react'

export default function CtaButton({ label, variant = 'primary', className = '', onClick, onDark = false, 'data-testid': testId, ...rest }) {
  const handleClick = onClick || (() => {
    window.dispatchEvent(new CustomEvent('booking:open'))
  })

  const base = 'inline-block typography-menu-text py-3 px-8 rounded-full transition-colors duration-200 cursor-pointer'
  const styles = {
    // When onDark=true for primary variant: invert to beige bg + primary text for legibility over dark sections
    primary:   onDark
      ? `${base} bg-color-bg-light text-color-primary hover:bg-color-secondary hover:text-primary-on-dark`
      : `${base} bg-color-primary text-primary-on-dark hover:bg-color-secondary`,
    secondary: `${base} border border-color-primary text-color-primary hover:bg-color-primary hover:text-primary-on-dark`,
    ghost:     `${base} text-color-secondary hover:text-color-primary`,
    inverted:  `${base} bg-primary-on-dark text-color-primary hover:bg-color-secondary hover:text-primary-on-dark`,
  }

  return (
    <button onClick={handleClick} className={`${styles[variant]} ${className}`} data-testid={testId || `cta-button-${variant}`} {...rest}>
      {label}
    </button>
  )
}
